import React from 'react';
import { useNavigate } from 'react-router-dom';
import { useNotifications } from '../context/NotificationContext';

export default function HelpDeskIcon() {
  const { chatUnread } = useNotifications();
  const navigate = useNavigate();

  return (
    <button
      onClick={() => navigate('/helpdesk')}
      title="Helpdesk"
      style={{ background: 'none', border: 'none', cursor: 'pointer', padding: '4px 8px', position: 'relative', color: '#6c757d', display: 'flex', alignItems: 'center' }}
    >
      <svg width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
        <path d="M21 15a2 2 0 0 1-2 2H7l-4 4V5a2 2 0 0 1 2-2h14a2 2 0 0 1 2 2z"/>
      </svg>
      {chatUnread > 0 && (
        <span style={{
          position: 'absolute', top: 0, right: 2,
          width: 8, height: 8, borderRadius: '50%',
          background: '#e74a3b', border: '1.5px solid #fff',
        }} />
      )}
    </button>
  );
}
